import * as Dialog from '@radix-ui/react-dialog';
import styled, { css } from 'styled-components';

import { resetButton, withDecoratedScroll } from 'styles/common';

export const Overlay = styled(Dialog.Overlay)`
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
`;

export const Content = styled(Dialog.Content)<{ $maxWidth?: number }>`
  ${withDecoratedScroll}
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 101;
  width: fit-content;
  max-height: calc(100vh - 36px);
  max-height: calc(100svh - 36px);
  max-width: calc(100vw - 16px);
  padding: 24px;
  border-radius: 28px;
  background: rgba(10, 8, 30, 0.95);
  border: 1px solid rgba(155, 89, 182, 0.3);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  overflow: auto;

  ${(props) =>
    props.$maxWidth &&
    css`
      width: calc(100vw - 16px);
      max-width: ${props.$maxWidth}px;
    `}

  @media (max-width: 600px) {
    padding: 16px 12px;
  }
`;

export const CloseButton = styled.button`
  ${resetButton}
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  background: transparent;
  border-radius: 8px;
  transition: background 0.2s;

  svg {
    width: 32px;
    height: 32px;

    path {
      fill: rgba(255, 255, 255, 0.7);
      transition: fill 0.2s;
    }
  }

  :hover {
    background: rgba(255, 255, 255, 0.1);

    svg path {
      fill: rgba(255, 255, 255, 1);
    }
  }

  @media (max-width: 600px) {
    top: 12px;
    right: 12px;
  }
`;
